// import { combineReducers } from "redux"
import tabs from "./tabs"

// const tabReducer = combineReducers({
//   tabs
// })

export default tabs
